import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import Button from '@material-ui/core/Button';
import styles from './Members.scss';
import {deleteSavedSearch, deleteAllSavedSearches} from '../../actions';
import SavedSearchCard from './SavedSearchCard';

class Searches extends Component {
  constructor(props) {
    super(props);
  }
  unsubscribeAll = () => {
    if (event) event.preventDefault();
    let ids = _map(this.props.userSavedSearches.savedSearches, 'searchId');
    this.props.deleteAllSavedSearches({searchIds: ids});
  }
  removeSearch = (searchId) => {
    this.props.deleteSavedSearch({searchId});
  }
  render() {
    const {userSavedSearches, history} = this.props;
    const hasSearches = userSavedSearches?.savedSearches?.length > 0;

    return (
      <div className="mt-5 mb-5">
        <div className={`row ${styles.poppins}`}>
          <h3 className="mb-0 mb-sm-3 col-sm-6">Saved Search Alerts</h3>
          <div className={`col-sm-6 text-sm-right ${styles.removeAllButton}`}>
            {hasSearches && <a href="." onClick={this.unsubscribeAll} title="Remove all Saved Searches">
              Remove all Saved Searches
            </a>}
          </div>
        </div>
        <span>Get updates on properties that match your saved search for listings or recent sales, including local market trends.</span>
        <div className="mt-4">
          {hasSearches &&
            userSavedSearches.savedSearches.map((search, index) => (
              <SavedSearchCard
                key={'savedSearch-' + index}
                searchURL={search.searchDetail.searchURL}
                name={search.name}
                searchId={search.searchId}
                removeSearch={this.removeSearch}
                searchData={search.searchDetail.data}
                alertFrequency={search.alertFrequency}
                query={search.query}
                sort={search.sort}
                location={search.searchDetail.location}
              />
            ))
          }
          {!hasSearches &&
            <div className={`rounded d-flex flex-column flex-lg-row ${styles.emptySavedSearch}`}>
              <img src="/assets/images/no-saved-search.png"/>
              <div className="d-flex ml-0 ml-lg-4 flex-column align-items-center text-center align-items-lg-start text-lg-left">
                <h3>Get notified about changes to your saved searches</h3>
                <p>Get alerts for new properties that match your saved searches.</p>
                <Button
                  className={`${styles.savedSearchButton}`}
                  variant={'contained'}
                  color={'primary'}
                  onClick={() => history.push('/')}>
                  Start searching now
                </Button>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

Searches.propTypes = {
  userSavedSearches: PropTypes.object,
  deleteAllSavedSearches: PropTypes.func,
  deleteSavedSearch: PropTypes.func,
  history: PropTypes.object,
};
const mapStateToProps = (state) => {
  return {userSavedSearches: state.userSavedSearches};
};
const mapDispatchToProps = {
  deleteSavedSearch,
  deleteAllSavedSearches,
};
export default connect(mapStateToProps, mapDispatchToProps)(Searches);
